import BaseApi from './base.api'

class PlanningApi extends BaseApi {
  companiesUrl = 'companies/'
  contactsUrl = 'contacts/'
  conversationsUrl = 'conversations/'
  equipmentsUrl = 'equipments/'
  equipmentConditionsUrl = 'equipment-conditions/'
  listingItemsUrl = 'listing-items/'
  listingsUrl = 'listings/'
  serviceTagsUrl = 'service-tags/'
  projectListingItemServicesUrl = 'project-listing-item-services/'
  projectListingItemsUrl = 'project-listing-items/'
  projectTagsUrl = 'project-tags/'
  projectsUrl = 'projects/'
  rentalCompaniesUrl = 'rental-companies/'
  groupsUrl = 'groups/'
  servicesUrl = 'services/'
  staffsUrl = 'staffs/'
  warehousesUrl = 'warehouses/'
  warehouseMovementsUrl = 'warehouse-movements/'
  warehouseStocksUrl = 'warehouse-stocks/'
  warehouseMinStocksUrl = 'warehouse-min-stocks/'

  archiveCompanyAsync = (id) => this.putAsync(`${this.companiesUrl}${id}/archive/`)
  archiveEquipmentAsync = (id, config) => this.putAsync(`${this.servicesUrl}${id}/archive/`, undefined, config)
  archiveGroupAsync = (id, config) => this.putAsync(`${this.groupsUrl}${id}/archive/`, undefined, config)
  archiveStaffAsync = (id, config) => this.putAsync(`${this.staffsUrl}${id}/archive/`, undefined, config)
  archiveProjectAsync = (id) => this.putAsync(`${this.projectsUrl}${id}/archive/`)
  archiveListingAsync = (id) => this.putAsync(`${this.listingsUrl}${id}/archive/`)
  archiveListingItemAsync = (id) => this.putAsync(`${this.listingItemsUrl}${id}/archive/`)

  resendInviteStaffAsync = (id) => this.postAsync(`${this.staffsUrl}${id}/resend-invite/`)

  cloneEquipmentAsync = (id) => this.postAsync(`${this.equipmentsUrl}${id}/clone/`)
  cloneGroupAsync = (id) => this.postAsync(`${this.groupsUrl}${id}/clone/`)
  cloneListingAsync = (id, data) => this.postAsync(`${this.listingsUrl}${id}/clone/`, data)
  cloneListingItemAsync = (id) => this.postAsync(`${this.listingItemsUrl}${id}/clone/`)

  deleteEquipmentAsync = (id, config) => this.deleteAsync(`${this.equipmentsUrl}${id}/`, config)
  deleteEquipmentConditionAsync = (id, config) => this.deleteAsync(`${this.equipmentConditionsUrl}${id}/`, config)
  deleteGroupAsync = (id, config) => this.deleteAsync(`${this.groupsUrl}${id}/`, config)
  deleteStaffAsync = (id, config) => this.deleteAsync(`${this.staffsUrl}${id}/`, config)
  deleteProjectAsync = (id, config) => this.deleteAsync(`${this.projectsUrl}${id}/`, config)
  deleteCompanyAsync = (id, config) => this.deleteAsync(`${this.companiesUrl}${id}/`, config)
  deleteListingAsync = (id, config) => this.deleteAsync(`${this.listingsUrl}${id}/`, config)
  deleteListingItemAsync = (id, config) => this.deleteAsync(`${this.listingItemsUrl}${id}/`, config)
  deleteProjectListingItemAsync = (id) => this.deleteAsync(`${this.projectListingItemsUrl}${id}/`)
  deleteProjectFileAsync = (id) => this.deleteAsync(`${this.projectsUrl}files/${id}`)
  deleteServiceFileAsync = (id) => this.deleteAsync(`${this.servicesUrl}files/${id}`)

  downloadProjectFileAsync = (id, fileName) => this.downloadAsync(`${this.projectsUrl}files/${id}`, fileName)
  downloadServiceFileAsync = (id, fileName) => this.downloadAsync(`${this.servicesUrl}files/${id}`, fileName)

  exportServicesExcelAsync = (resourceUrl, fileName, ids) => this.downloadAsync(`${resourceUrl}export-excel/`, fileName, null, { data: { ids }, method: 'post' })
  exportListingsAsync = (params) => this.downloadAsync(`${this.listingsUrl}export-excel/`, 'listings.xlsx', null, { data: {ids: params}, method: 'post' })
  exportProjectsExcelAsync = (ids, templateId, fileName, groupByPrimaryBudgetTags = false) => this.downloadAsync(`${this.projectsUrl}export-excel/`, fileName, null, { data: { ids, template_id: templateId, group_by_primary_budget_tags: groupByPrimaryBudgetTags }, method: 'post' })

  getCompaniesAsync = (params) => this.getAsync(this.companiesUrl, params)
  getCompanyByIdAsync = (id, params) => this.getAsync(`${this.companiesUrl}${id}`, params)
  getCompanyStatisticsByIdAsync = (id) => this.getAsync(`${this.companiesUrl}${id}/statistics/`)
  getCompanyRoiByIdAsync = (id) => this.getAsync(`${this.companiesUrl}${id}/roi/`)
  getCompanyTimelineByIdAsync = (id, params) => this.getAsync(`${this.companiesUrl}${id}/timeline/`, params)
  getContactsAsync = (params) => this.getAsync(this.contactsUrl, params)
  getConversationsAsync = (params) => this.getAsync(this.conversationsUrl, params)
  getEquipmentByIdAsync = (id) => this.getAsync(`${this.equipmentsUrl}${id}`)
  getEquipmentByUuidAsync = (uuid) => this.getAsync(this.equipmentsUrl, { uuid: uuid })
  getGroupByIdAsync = (id) => this.getAsync(`${this.groupsUrl}${id}`)
  getEquipmentQrcodeByIdAsync = (id) => this.getAsync(`${this.equipmentsUrl}${id}/qrcode/`)
  getEquipmentStatsByIdAsync = (id) => this.getAsync(`${this.equipmentsUrl}${id}/stats/`)
  checkEquipmentSerializedAsync = (id) => this.getAsync(`${this.equipmentsUrl}${id}/check-serialized/`)
  getEquipmentsAsync = (params) => this.getAsync(this.equipmentsUrl, params)
  getEquipmentConditionsByEquipmentIdAsync = (equipmentId, params) => this.getAsync(this.equipmentConditionsUrl, { ...params, equipment: equipmentId })
  getEquipmentSerialInstancesAsync = (equipmentId) => this.getAsync(`${this.equipmentsUrl}${equipmentId}/serial-instances/`)
  addEquipmentSerialAsync = (equipmentId, data) => this.postAsync(`${this.equipmentsUrl}${equipmentId}/add-serial/`, data)
  deleteEquipmentSerialAsync = (equipmentId, serialId) => this.deleteAsync(`${this.equipmentsUrl}${equipmentId}/delete-serial/${serialId}/`)
  getListingItemsAsync = (params) => this.getAsync(this.listingItemsUrl, params)
  getListingItemByIdAsync = (id, params) => this.getAsync(`${this.listingItemsUrl}${id}`, params)
  getListingsAsync = (params) => this.getAsync(this.listingsUrl, params)
  getListingByIdAsync = (id, params) => this.getAsync(`${this.listingsUrl}${id}`, params)
  getProjectByIdAsync = (id) => this.getAsync(`${this.projectsUrl}${id}`, { show_archived: true })
  getProjectBudgetRowsAsync = (projectId) => this.getAsync(`${this.projectsUrl}${projectId}/budget-rows/`)
  getProjectListingItemsAsync = (projectId, params) => this.getAsync(this.projectListingItemsUrl, { ...params, project: projectId })
  getProjectListingItemsByProjectIdAsync = (projectId, params) => this.getAsync(this.projectListingItemsUrl, { ...params, project: projectId })
  getProjectListingItemServicesAsync = (params) => this.getAsync(this.projectListingItemServicesUrl, params)
  getProjectListingItemServicesByProjectIdAsync = (projectId, params) => this.getProjectListingItemServicesAsync({ ...params, project: projectId })
  getProjectActiveSummaryAsync = (params) => this.getAsync(`${this.projectsUrl}active-summary/`, params)
  getProjectPipelineSummaryAsync = () => this.getAsync(`${this.projectsUrl}pipeline-summary/`)
  getEquipmentConditionSummaryAsync = () => this.getAsync(`${this.equipmentsUrl}condition-summary/`)
  getEquipmentAttentionCountAsync = (params) => this.getAsync(`${this.equipmentsUrl}attention-count/`, params)
  getBrokenEquipmentSummaryAsync = (params) => this.getAsync(`${this.equipmentsUrl}broken-summary/`, params)
  getPendingApprovalsSummaryAsync = () => this.getAsync(`${this.warehouseMovementsUrl}pending-summary/`)
  getEquipmentRepairOnTimeAsync = () => this.getAsync(`${this.equipmentsUrl}repair-on-time/`)
  getGrossMarginSummaryAsync = () => this.getAsync(`${this.projectsUrl}gross-margin-summary/`)
  getRevenueTargetSummaryAsync = () => this.getAsync(`${this.projectsUrl}revenue-target-summary/`)
  getQuarterGlanceAsync = () => this.getAsync(`${this.projectsUrl}quarter-glance/`)
  getProjectsAsync = (params) => this.getAsync(this.projectsUrl, params)
  getProjectServicesByProjectIdAsync = (projectId) => this.getAsync(`${this.projectsUrl}${projectId}/services/`)
  getRentalCompaniesAsync = (params) => this.getAsync(this.rentalCompaniesUrl, params)
  getGroupsAsync = (params) => this.getAsync(this.groupsUrl, params)
  getServicesAsync = (params) => this.getAsync(this.servicesUrl, params)
  getServiceComponentTreeAsync = (serviceIds) => this.getAsync(`${this.servicesUrl}component-tree/`, { service_ids: [].concat(serviceIds).join(',') })
  getServiceEventsAsync = (id, params) => this.getAsync(`${this.servicesUrl}${id}/events/`, params)
  getProjectKpiChartAsync = (metric, period, params) => this.getAsync(`${this.projectsUrl}kpi-chart/`, { metric, period, ...params })
  getStaffAvailableTodayAsync = (params) => this.getAsync(`${this.staffsUrl}available-today/`, params)
  getStaffsAsync = (params) => this.getAsync(this.staffsUrl, params)
  getStaffByIdAsync = (id, params) => this.getAsync(`${this.staffsUrl}${id}`, params)

  downloadEquipmentQrCodesAsync = (fileName, data) => this.downloadAsync(`${this.equipmentsUrl}print-qrcodes/`, fileName, null, { data, method: 'post' })

  printProjectDeliveryNoteAsync = (id, fileName, params) => this.downloadAsync(`${this.projectsUrl}${id}/delivery-note/`, fileName, null, { params })
  previewProjectDeliveryNoteAsync = (id, params) => this.getBlobUrlAsync(`${this.projectsUrl}${id}/delivery-note/`, params)

  upsertCompanyAsync = (data) => this.upsertAsync(this.companiesUrl, data)
  upsertEquipmentAsync = (data, params) => this.upsertAsync(this.equipmentsUrl, data, { params: params })
  upsertEquipmentConditionAsync = (data, params) => this.upsertAsync(this.equipmentConditionsUrl, data, { params: params })
  upsertListingAsync = (data) => this.upsertAsync(this.listingsUrl, data)
  upsertListingItemAsync = (data) => this.upsertAsync(this.listingItemsUrl, data)
  addServiceTagAsync = (data) => this.postAsync(this.serviceTagsUrl, data)
  getServiceTagsAsync = (params) => this.getAsync(this.serviceTagsUrl, params)

  addProjectTagAsync = (data) => this.postAsync(this.projectTagsUrl, data)
  getProjectTagsAsync = (params) => this.getAsync(this.projectTagsUrl, params)

  upsertProjectAsync = (data) => this.upsertAsync(this.projectsUrl, data)
  upsertProjectListingItemAsync = (data) => this.upsertAsync(this.projectListingItemsUrl, data)
  upsertProjectListingItemServiceAsync = (data, params, config) => this.upsertAsync(this.projectListingItemServicesUrl, data, { params: params, ...config })
  upsertGroupAsync = (data) => this.upsertAsync(this.groupsUrl, data)
  upsertStaffAsync = (data) => this.upsertAsync(this.staffsUrl, data)

  archiveWarehouseAsync = (id, config) => this.putAsync(`${this.warehousesUrl}${id}/archive/`, null, config)
  deleteWarehouseAsync = (id, config) => this.deleteAsync(`${this.warehousesUrl}${id}/`, config)
  getWarehousesAsync = (params) => this.getAsync(this.warehousesUrl, params)
  upsertWarehouseAsync = (data) => this.upsertAsync(this.warehousesUrl, data)

  deleteWarehouseMovementAsync = (id, config) => this.deleteAsync(`${this.warehouseMovementsUrl}${id}/`, config)
  getWarehouseMovementsAsync = (params) => this.getAsync(this.warehouseMovementsUrl, params)
  upsertWarehouseMovementAsync = (data) => this.upsertAsync(this.warehouseMovementsUrl, data)
  confirmWarehouseMovementAsync = (id, force = false, config) => this.putAsync(`${this.warehouseMovementsUrl}${id}/confirm/`, { force }, config)
  revertWarehouseMovementAsync = (id) => this.putAsync(`${this.warehouseMovementsUrl}${id}/revert/`)
  getWarehouseMovementTwinAsync = (id) => this.getAsync(`${this.warehouseMovementsUrl}${id}/twin/`)

  getWarehouseStocksAsync = (params) => this.getAsync(this.warehouseStocksUrl, params)
  getStockAvailabilityAsync = (params) => this.getAsync(`${this.warehouseStocksUrl}stock-availability/`, params)

  dashboardTilesUrl = 'dashboard-tiles/'
  dashboardKpiMetricsUrl = 'dashboard-kpi-metrics/'
  dashboardTemplateChartsUrl = 'dashboard-template-charts/'
  dashboardDefaultLayoutsUrl = 'dashboard-default-layouts/'
  getDashboardCatalogAsync = () => this.getAsync(`${this.dashboardTilesUrl}catalog/`)
  updateDashboardTileAsync = (id, data) => this.patchAsync(`${this.dashboardTilesUrl}${id}/`, data)
  updateDashboardKpiMetricAsync = (id, data) => this.patchAsync(`${this.dashboardKpiMetricsUrl}${id}/`, data)
  updateDashboardTemplateChartAsync = (id, data) => this.patchAsync(`${this.dashboardTemplateChartsUrl}${id}/`, data)
  upsertDashboardDefaultLayoutAsync = (data) => this.upsertAsync(this.dashboardDefaultLayoutsUrl, data)
}

export const planningApi = new PlanningApi('planning/')
